module.exports = __webpack_public_path__ + "static/img/1.602bfcc5.png";